// import React from "react";
// // import AuthService from './Services/AuthService'
// import { Route, Routes } from "react-router-dom";
// import Login from "./components/layout/Login";
// import { Navigate } from 'react-router-dom';
// const PrivateRoute = ({ component: Component, ...rest }) => {

//     var isLoggedIn = false;
//     const parseJwt = (token) => {
//         try {
//             return JSON.parse(atob(token.split('.')[1]));
//         } catch (e) {
//             return null;
//         }
//     };

//     var roles = JSON.parse(localStorage.getItem("MCData"));

//     const decodedJwt = parseJwt(roles?.token);
//     if (roles == null) {
//         isLoggedIn = false;

//     }
//     else if (decodedJwt.exp * 1000 < Date.now()) {
//         isLoggedIn = false;
//     }
//     else if (roles && roles.type=="U" &&

//         (
//             (

//                 (window.location.href.indexOf("settingsuser") > -1)
//                 || (window.location.href.indexOf("list") > -1)
//             )
//         )
//     ) {
//         isLoggedIn = false;
//     }
//     else if (roles &&

//         (
//             (
//                 (window.location.href.indexOf("dashboard") > -1) || (window.location.href.indexOf("Waters")) || (window.location.href.indexOf("settings") > -1) ||
//                 (window.location.href.indexOf("settingsuser") > -1) || (window.location.href.indexOf("notification") > -1) || (window.location.href.indexOf("accountnames") > -1) || (window.location.href.indexOf("/outliers") > -1) ||
//                 (window.location.href.indexOf("devices") > -1)
//                 ||
//                 (window.location.href.indexOf("stats") > -1) || (window.location.href.indexOf("totalflow") > -1) || (window.location.href.indexOf("registration") > -1)
//                 || (window.location.href.indexOf("list") > -1)
//             )
//         )
//     ) {
//         isLoggedIn = true;
//     }
//     return (
//         <Route
//             {...rest}
//             render={(props) =>
//                 isLoggedIn ? (
//                     <Component {...props} />
//                 ) : (

//                      <Navigate
//                      to="/login"
//                      state={{ from: location }}
//                      replace
//                     />
//                 )
//             }
//         />
//     );
// };

// export default PrivateRoute;
// PrivateRoute.jsx

// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";

// const PrivateRoute = ({ children }) => {
//   const location = useLocation();
//   const roles = JSON.parse(localStorage.getItem("MCData"));

//   const isTokenValid = () => {
//     try {
//       const decoded = JSON.parse(atob(roles?.token?.split(".")[1]));
//       return decoded.exp * 1000 > Date.now();
//     } catch {
//       return false;
//     }
//   };

//   const isAllowed = roles && isTokenValid();

//   return isAllowed ? children : <Navigate to="/login" state={{ from: location }} replace />;
// };

// export default PrivateRoute;

import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const roles = JSON.parse(localStorage.getItem("MCData"));

  const isTokenValid = () => {
    try {
      const decoded = JSON.parse(atob(roles?.token?.split(".")[1]));
      return decoded.exp * 1000 > Date.now();
    } catch {
      localStorage.clear();
      return false;
    }
  };

  const isLoggedIn = roles && isTokenValid();

  if (!isLoggedIn) {
    localStorage.clear();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const userRole = roles?.mcdatas?.type || roles?.type;
  const currentUrl = window.location.href;

  if (
    userRole === "U" &&
    (currentUrl.includes("settingsuser") ||
      currentUrl.includes("list") ||
      currentUrl.includes("schematics") ||
      currentUrl.includes("metermanagement") ||
      currentUrl.includes("stats") ||
      currentUrl.includes("devices"))
  ) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const allowedPaths = [
    "dashboard",
    "Waters",
    "settings",
    "settingsuser",
    "notification",
    "accountnames",
    "/outliers",
    "devices",
    "stats",
    "totalflow",
    "registration",
    "schematics",
    "alert",
    "metermanagement",
    "Wateragg",
    "watermeterreadings",
    "predictiveanalysis",
    "Anomaly",
    "profile",
    "list",
    "flowhealth",
    "health",
    "meterhistory",
  ];

  const isAllowedPath = allowedPaths.some((path) => currentUrl.includes(path));

  if (!isAllowedPath) {
    localStorage.clear();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
